<template>
    <div>
        <el-input-number v-model="number" style="width:200px;" :placeholder="config.placeholder" clearable
            controls-position="right"></el-input-number>
    </div>
</template>

<script>
export default {
    name: 'FromNumber',
    components: {},
    props: {
        value: {
            type: Number | String,
            default: null
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        number(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.number = value
        }
    },
    data() {
        return {
            number: this.value
        }
    },
    methods: {

    }
}
</script>
